import * as yup from 'yup';

import { Alert, Button, Col, Form, Modal } from 'react-bootstrap';
import { page, pageSize } from '../../constants/path';
import {
  savePhoneList,
  tenantAttributeInfos,
} from '../../pages/Attribute/AttributeSlice';
import { useDispatch, useSelector } from 'react-redux';

import React from 'react';
import { getDataDevice } from '../../pages/Device/DeviceSlice';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';

const addDeviceSchema = yup.object().shape({
  phone: yup.string().required('Phone is a required field.'),
  name: yup.string().required('Name is a required field.'),
});

function ModalPhoneList({
  type,
  show,
  setShow,
  deviceId,
  listPhone,
  name,
  index,
}) {
  const { t } = useTranslation();
  const token = localStorage.getItem('token');
  const typeAcc = useSelector((state) => state.profile.profile.authority);
  const dispatch = useDispatch();
  const dataCustomer = useSelector((state) => state.profile.profile);

  // let index = listPhone.findIndex((value) => value.name === name);
  const currentPhone = listPhone?.filter((value) => value.name === name);

  const handleClose = () => {
    resetField('name');
    resetField('phone');
    setShow(false);
  };

  const {
    register,
    resetField,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: currentPhone?.[0]?.name,
      phone: currentPhone?.[0]?.phone,
    },
    resolver: yupResolver(addDeviceSchema),
  });

  const onSubmit = async (data) => {
    if (type === 'edit') {
      let dataPhone = [...listPhone];
      dataPhone[index] = data;
      await dispatch(savePhoneList({ token, dataPhone, deviceId }));
    } else if (type === 'delete') {
      let dataPhone = [...listPhone];
      dataPhone.splice(index, 1);
      await dispatch(savePhoneList({ token, dataPhone, deviceId }));
    } else {
      const dataPhone = [...listPhone, data];
      await dispatch(savePhoneList({ token, dataPhone, deviceId }));
    }

    if (typeAcc === 'TENANT_ADMIN') {
      await dispatch(tenantAttributeInfos({ token }));
    } else {
      const customerId = dataCustomer?.customerId?.id;
      if (customerId)
        await dispatch(getDataDevice({ token, customerId, pageSize, page }));
    }
    resetField('phone');
    resetField('name');
    setShow(false);
  };

  return (
    <Modal onHide={handleClose} size="lg" show={show}>
      <Modal.Header closeButton>
        <Modal.Title>
          {type === 'add-new'
            ? t('add-new')
            : type === 'edit'
            ? t('edit')
            : t('delete') + ' ' + t('phone')}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          {type === 'delete' ? (
            <span>{t('delete-message')}</span>
          ) : (
            <>
              <Form.Group as={Col} controlId="name">
                <Form.Label>
                  <span>
                    <i
                      className="fa fa-asterisk"
                      style={{ color: 'red', fontSize: '10px' }}
                      aria-hidden="true"
                    ></i>{' '}
                  </span>
                  {t('name')}:
                </Form.Label>
                <Form.Control
                  disabled={type === 'delete' && true}
                  type="text"
                  placeholder={t('name')}
                  {...register('name')}
                  defaultValue={currentPhone?.[0]?.name}
                />
                {errors.name && (
                  <Alert
                    variant="danger"
                    style={{
                      padding: '5px',
                      height: '32px',
                      marginTop: '4px',
                    }}
                  >
                    <p>{errors.name.message}</p>
                  </Alert>
                )}
              </Form.Group>
              <Form.Group as={Col} controlId="phone">
                <Form.Label>
                  <span>
                    <i
                      className="fa fa-asterisk"
                      style={{ color: 'red', fontSize: '10px' }}
                      aria-hidden="true"
                    ></i>{' '}
                  </span>
                  {t('phone')}:
                </Form.Label>
                <Form.Control
                  disabled={type === 'delete' && true}
                  type="text"
                  placeholder={t('phone')}
                  {...register('phone')}
                  defaultValue={currentPhone?.[0]?.phone}
                />
                {errors.phone && (
                  <Alert
                    variant="danger"
                    style={{
                      padding: '5px',
                      height: '32px',
                      marginTop: '4px',
                    }}
                  >
                    <p>{errors.phone.message}</p>
                  </Alert>
                )}
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t('close')}
          </Button>
          <Button variant="primary" type="submit">
            {type === 'add-new'
              ? t('add-new')
              : type === 'edit'
              ? t('edit')
              : t('delete')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ModalPhoneList;
